import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getPaymentDetails } from "../components/redux/main-reducer";

const INACTIVITY_TIMEOUT = 10 * 60 * 1000; // 10 минут в миллисекундах

export const useIdleTimer = (isEnabled) => {
  const [lastActivity, setLastActivity] = useState(Date.now());
  const paymentDetails = useSelector(getPaymentDetails);

  React.useEffect(() => {
    if (!isEnabled) return;

    const resetTimer = () => setLastActivity(Date.now());

    const checkInactivity = () => {
      if (Date.now() - lastActivity > INACTIVITY_TIMEOUT) {
        window.location.replace(`${paymentDetails?.failure_url}`);
      }
    };

    const events = ["mousemove", "keydown", "scroll", "click"];
    events.forEach((event) => window.addEventListener(event, resetTimer));

    const interval = setInterval(checkInactivity, 10000); // Проверка каждые 10 сек

    return () => {
      events.forEach((event) => window.removeEventListener(event, resetTimer));
      clearInterval(interval);
    };
  }, [lastActivity]);

  return null;
};
